

















































import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'ProfileTeoAu',
  // props: {
  // },
  components: {},
  setup: () => {
    return {};
  }
});
